import { skipToken, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function useAllTasks() {
  const trpc = useTRPC()
  return useQuery(trpc.tasks.listAll.queryOptions())
}

export function useTasks(projectId: string) {
  const trpc = useTRPC()
  return useQuery(trpc.tasks.list.queryOptions(projectId || skipToken))
}

function useInvalidateTasks() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return () =>
    Promise.all([
      queryClient.invalidateQueries(trpc.tasks.list.pathFilter()),
      queryClient.invalidateQueries(trpc.tasks.listAll.pathFilter())
    ])
}

export function useCreateTask() {
  const trpc = useTRPC()
  const invalidate = useInvalidateTasks()
  return useMutation(trpc.tasks.create.mutationOptions({ onSuccess: invalidate }))
}

export function useUpdateTask() {
  const trpc = useTRPC()
  const invalidate = useInvalidateTasks()
  return useMutation(trpc.tasks.update.mutationOptions({ onSuccess: invalidate }))
}
